var $2a2d5dc14e680587$exports = {};
$2a2d5dc14e680587$exports = {
  "alpha": "Alpha",
  "black": "Noir",
  "blue": "Bleu",
  "blue purple": "Violet bleu",
  "brightness": "Luminosit\xE9",
  "brown": "Brun",
  "brown yellow": "Jaune brun",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "Cyan",
  "cyan blue": "Bleu cyan",
  "dark": "Sombre",
  "gray": "Gris",
  "grayish": "Gris\xE2tre",
  "green": "Vert",
  "green cyan": "Cyan vert",
  "hue": "Teinte",
  "light": "Clair",
  "lightness": "Luminosit\xE9",
  "magenta": "Magenta",
  "magenta pink": "Rose magenta",
  "orange": "Orange",
  "orange yellow": "Jaune orang\xE9",
  "pale": "P\xE2le",
  "pink": "Rose",
  "pink red": "Rouge ros\xE9",
  "purple": "Violet",
  "purple magenta": "Magenta violet",
  "red": "Rouge",
  "red orange": "Orange rouge",
  "saturation": "Saturation",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " transparent");
  },
  "very dark": "Tr\xE8s sombre",
  "very light": "Tr\xE8s clair",
  "vibrant": "Vif",
  "white": "Blanc",
  "yellow": "Jaune",
  "yellow green": "Vert jaune"
};
export { $2a2d5dc14e680587$exports as default };